import Vue from 'vue'
import Vuex, {Dictionary} from 'vuex'

// @ts-ignore
import Cookies from 'js-cookie';

import appInterface from './appInterface'
import user from './user'
import users from './users'
import orgs from './orgs'
import students from './students'
import saveGuard from './saveGuard'
import preheaders from './preheaders'
import mailing from './mailing'
import sched from './sched'
import wiki from './wiki'
import poll from './polls'
import messages from './messages'
import notify from './notify'

import axios, {AxiosRequestConfig} from 'axios'
import config from '@/config'
import errors from '@/services/errors'
import auth from '../services/auth'
import LoaderBar from '../services/loaderBar'

import {RootState} from '@/types/store/states'

import {E_ACCESS, E_SESS, E_SESS_INACTIVE, E_TYPE_REQUESR, CONF_BASE_URL, API} from '@/constants'
import {Notification, Message} from 'element-ui'
import router from '@/routes'
Vue.use(Vuex)

export default new Vuex.Store<RootState>({
  modules: {
    user,
    users,
    orgs,
    saveGuard,
    appInterface,
    preheaders,
    students,
    mailing,
    sched,
    wiki,
    poll,
    messages,
    notify
  },
  // @ts-ignore
  state: {
    sidebarOpened: false,
    sidebarMinimized: false,
    bodyMaximized: false,
    resizePanelsHovered: false,
    serverTime: 0,
    lang: Cookies.get('lang_checked') || 'en'
  },
  mutations: {
    sidebarOpened: (state, opened) => {
      state.sidebarOpened = opened !== undefined ? opened : !state.sidebarOpened
    },
    sidebarMinimized: (state, minimized) => {
      state.sidebarMinimized = minimized !== undefined ? minimized : !state.sidebarMinimized
    },
    bodyMaximized: (state, maximized) => {
      state.bodyMaximized = maximized !== undefined ? maximized : !state.bodyMaximized
    },
    resizePanelsHovered: (state, hovered) => {
      state.resizePanelsHovered = hovered !== undefined ? hovered : !state.resizePanelsHovered
    },
    setServerTime: (state, serverTime) => {
      state.serverTime = Number(serverTime);
    },
    setLang: (state, lang) => {
      state.lang = lang;
    }
  },
  getters: {
    sidebarOpened: store => store.sidebarOpened,
    sidebarMinimized: store => store.sidebarMinimized,
    bodyMaximized: store => store.bodyMaximized,
    resizePanelsHovered: store => store.resizePanelsHovered
  },
  actions: {
    /**
     * Отключить троу ошибок с статусом не 200
     *
     * сохранять запрос
     *
     * Варианты ответа
     * статус 200, дата ок
     * статус 200, ошибка
     * статус 304+, дата ок
     * статус 304+, дата в виде сртоки
     * статус 500+, ответил nginx, дата не ок
     * Нет ответа (инет упал) (улетает в catch)
     * Если статус 401:
     *   есть рефреш - удалить токен, сходить сделать рефшер, записать новый токен, повторить запрос (1 раз)
     *   нет рефреша - логаут и на страницу логина
     * Если Е_СЕСС логаут и на станицу логина
     */
    async apiRequest (context, {url = '/api', method, data = {}, flag, contentType = 'application/json', refresh = false}) {
      try {
        let requester = async function () {
          const HTTP = axios.create({
            baseURL: config(CONF_BASE_URL),
            validateStatus: () => true
          })
          const headers: Dictionary<string> = {
            'Content-Type': contentType
          }

          if (auth.readToken()) {
            headers['Authorization'] = 'Bearer ' + auth.readToken()
          }

          let options: AxiosRequestConfig = {
            method: 'post',
            timeout: flag === 'ignoreTimeout' ? 300000 : 30000,
            headers,
            url
          }

          if (method) {
            options.data = {
              method,
              params: data
            }
            options.params = method
          } else {
            options.data = data
          }
          let request = HTTP.request(options);
          if (flag !== 'silent') {
            LoaderBar.start(request)
          }
          let response = await request;
          if (flag !== 'silent') {
            LoaderBar.stop(request)
          }
          return response;
        }


        let response = await requester()

        if (response.status >= 400 && response.status !== 401) {
          if (response.status >= 502) {
            // @ts-ignore
            Message.error(messages.labels.server_not_working);
          }
          throw response;
        }

        if (response.headers['x-servertime']) {
          context.commit('setServerTime', response.headers['x-servertime'])
        }

        let firstReq = true
        if (response.status === 401) {
          const refToken = auth.readRefreshToken()
          if (refToken && !refresh) {
            firstReq = false
            await context.dispatch('user/loginRefresh', refToken)
            response = await requester()
          } else {
            router.push('/login')
            context.dispatch('user/logout');
            throw response;
          }
        }

        if (response.data.error) {
          throw response;
        }
        return response.data.result || response.data
      } catch (error) {
        const newError = errors(error.response || error, E_TYPE_REQUESR)
        console.log('LOG: apiRequest -> newError', newError)
        throw newError;
      }
    },
    async logExternal (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.crop.entery,
        method: API.crop.logExternal,
        flag: 'silent',
        data
      }, {root: true})
      return response;
    }
  }
})